import type React from 'react';

import { Image } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

type ResponsiveImageProps = {
	alt: string;
	webpUrl: string;
	webpUrl2x: string;
	pngUrl: string;
	pngUrl2x: string;
	className?: string;
};

export const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
	alt,
	webpUrl,
	webpUrl2x,
	pngUrl,
	pngUrl2x,
	className,
}) => {
	return (
		<picture>
			<source type="image/webp" srcSet={`${webpUrl} 1x, ${webpUrl2x} 2x`} />
			<Image src={pngUrl} srcSet={`${pngUrl} 1x, ${pngUrl2x} 2x`} alt={alt} className={cn('aspect-auto', className)} />
		</picture>
	);
};
